const Step = () => {
    // nothing to do here since it is only the props we are interested in
    return null;
};
export default Step;
